import * as Yup from "yup";
import { ENTITY_TYPE_IDS } from "v2/constants/entityTypes";
import { AddEntityMode } from "../AddAnotherEntityDropdown";

export const buildAddEntitySchema = (
  mode: AddEntityMode,
  showBusinessAddress: boolean,
  showDateField: boolean,
  requireStateField: boolean,
  usCountryIds: string[]
) => {
  const isUsIncorporation = (incorporationCountryId: string) =>
    usCountryIds.includes(incorporationCountryId);

  const addressField = (label: string) =>
    Yup.string()
      .trim()
      .when("incorporationCountryId", {
        is: isUsIncorporation,
        then: (schema) => schema.required(`${label} is required`),
      });

  return Yup.object({
    incorporationCountryId: Yup.string().required("Country is required"),
    formationTypeId: Yup.string().required("Entity type is required"),
    entityName: Yup.string().trim().required("Legal entity name is required"),
    ...(requireStateField
      ? {
          cStateId: Yup.string().when("incorporationCountryId", {
            is: isUsIncorporation,
            then: (schema) =>
              schema.required("State of incorporation is required"),
          }),
        }
      : {}),
    ...(showDateField
      ? {
          dateOfIncorporation: Yup.string().required(
            "Date of incorporation is required"
          ),
        }
      : {}),
    taxedAs: Yup.string().when("formationTypeId", {
      is: ENTITY_TYPE_IDS.llc,
      then: (schema) => schema.required("Tax classification is required"),
    }),
    relatedEntityId:
      mode === "separate"
        ? Yup.string()
        : Yup.string().required("Related entity is required"),
    ...(showBusinessAddress
      ? {
          streetAddress: addressField("Street address"),
          city: addressField("City"),
          country: addressField("Country"),
          state: addressField("State"),
          zipcode: addressField("Zipcode"),
        }
      : {}),
  });
};
